import { type ITFGAnalyticsCallbackParams } from '../../types';

/**
 * This function formats our analytics callback payload to be sent to the analytics service, specifically for AtlasKit AnalyticsEvent.
 * @param payload Our AnalyticsCallbackParams we standardize in package.
 * @returns Formatted payload for AtlasKit AnalyticsEvent to be sent to the analytics service.
 */
export const formatEventCallBackPayloadForAtlasKitAnalyticsEvent = ({
	action,
	actionSubject,
	actionSubjectId,
	attributes,
	source,
	type,
	name,
}: ITFGAnalyticsCallbackParams) => ({
	type,
	data: {
		action,
		actionSubject,
		actionSubjectId,
		attributes,
		source,
		...(name && { name }),
	},
});
